import React from 'react';

const PrivacyPolicy: React.FC = () => {
  const contactInformation = "deckhopper@christinak.ca";

  return (
    <div className="bg-dark-blue text-gray-300 p-8 w-[100em] pb-10">
        <h1 className="text-3xl font-bold text-center mb-4">Privacy Policy for Deck Hopper Pro</h1>
        <p className="text-center mb-4">
          This document outlines the privacy practices for Deck Hopper Pro application available at <a href="https://play.google.com/store/apps/details?id=ca.christinak.DeckHopperPro" target="_blank" rel="noopener noreferrer" className="text-amber-500 underline">Google Play Store</a> for Android devices and <a href="https://christinak.itch.io/deck-hopper" target="_blank" rel="noopener noreferrer" className="text-amber-500 underline">Itch.io</a> for desktop computers.
        </p>
        <hr className="border-t border-gray-500 my-4 mx-auto w-3/4"/>

        {/* Providing contact information for privacy-related inquiries */}
        <p className="mb-4 text-center">
            For privacy-related concerns, contact us at: <a href={`mailto:${contactInformation}`} className="text-amber-500 underline">{contactInformation}</a>.
        </p>

        {/* The rest of your privacy policy contents */}
        <h5 className="text-xl mb-2">Personal Information:</h5>
        <p className="mb-4">This app, developed by Christina Kral, may request Google login for verifying your license.</p>
        <p className="mb-4">Additionally, the app may collect user emails to link their purchases of Deck Hopper Pro across different platforms, such as Desktop or iOS.</p>

        <h5 className="text-xl mb-2">Storage and Protection:</h5>
        <p className="mb-4">The personal information may be stored on a secure Firebase server and is protected by Firebase measures.</p>
        <h5 className="text-xl mb-2">Use of Information:</h5>
        <p className="mb-4">The collected information will only be used for the purposes of verifying your license, providing support, and linking your purchases across platforms.</p>

        <h5 className="text-xl mb-2">Sharing Information:</h5>
        <p className="mb-4">No personal information will be shared with third parties, except as necessary for storage on Firebase servers or as required by law.</p>

        <h5 className="text-xl mb-2">Opt-Out and Deletion:</h5>
        <p className="mb-4">Users have the ability to opt-out and request deletion of their information by contacting us at the provided contact information.</p>

        <h5 className="text-xl mb-2">Data Security:</h5>
        <p className="mb-4">The app connects to a local SAMMI Core. It is the user's responsibility to secure any remote connections they choose to establish, such as via ngrok.</p>

        <h5 className="text-xl mb-2">Compliance:</h5>
        <p className="mb-4">It is the user's responsibility to ensure compliance with applicable data protection laws, including securing their own data when using our software.</p>

        {/* Add comprehensive disclosure of data handling */}
        <h5 className="text-xl mb-2">Data Collection and Use:</h5>
        <p className="mb-4">
            Our app accesses and collects the following types of personal and sensitive user data: email addresses license verification and for linking purchases across platforms. This information is not shared with any third parties except for storage on secure Firebase servers.
        </p>

        {/* Add data retention and deletion policy */}
        <h5 className="text-xl mb-2">Data Retention and Deletion:</h5>
        <p className="mb-4">
            We retain collected information for as long as necessary to provide the requested service. Users can delete their information by opting out of our service as described in our policy.
        </p>

        {/* Secure data handling procedures */}
        <h5 className="text-xl mb-2">Secure Data Handling:</h5>
        <p className="mb-4">
            We follow strict data handling and security procedures to ensure the protection of user data, consistent with industry standards and applicable data protection laws.
        </p>

        {/* Compliance section */}
        <h5 className="text-xl mb-2">Compliance with Legal Requirements:</h5>
        <p className="mb-4">
            We will comply with all applicable legal requirements regarding the collection, storage, use, and sharing of your personal data.
        </p>
    </div>
  );
};

export default PrivacyPolicy;
